<template>
    <div class="el-tooltip  el-tiptap-editor__command-button" @click="handleClick">
        <el-tooltip  effect="dark" content="清除格式" placement="top">
            
            <div class="el-tooltip el-tiptap-editor__command-button el-popover__reference">
                <i class="wjpc-iconfont wjpc-icon-qingchugeshi"></i>
            </div>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    // 自定义高级编辑组件
    name: "ClearFormatComponent",
    data() {
        return {
        }
    },
    computed:{
    },
    watch: {
    },
    created() {
    },
    methods: {
        handleClick() {
            this.$emit("click");
        }
    }
};
</script>

<style lang="scss" scoped>
.el-icon-edit-outline{
    font-weight: bold !important;
}
.command-button{
    border: 1px solid transparent;
    box-sizing: border-box;
    align-items: center;
    border-radius: 50%;
    color: #303133;
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 40px;
    margin: 2px;
    outline: 0;
    transition: all .2s ease-in-out;
    width: 27px !important;
    height: 18px !important;
    margin-top:4px;
}
</style>